<template>
  <component :is="layout">
    <router-view :key="$route.fullPath" />
    <app-modal />
  </component>
</template>

<script>
import Vue from 'vue';
import AppModal from '@/components/modals/AppModal';

export default {
  name: 'App',
  components: {
    AppModal
  },
  computed: {
    layout() {
      let layout = this.$route.meta.layout || 'LayoutDefault';
      if (!Vue.options.components[layout]) {
        Vue.component(layout, () => import(`@/layouts/${layout}.vue`));
      }

      return layout;
    }
  }
};
</script>

<style>
@import 'nprogress/nprogress.css';

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
  display: none;
}
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
  display: none;
}
.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
  display: none;
}
</style>
